<template>
  <transition name='fade'>
    <div class="modal video_view"
         v-if='visible'>
      <div class="video_view_content">
        <div class="video_view_title msp_icon_close">
          <span>{{videoInfo.title}}</span>
          <span class="iconfont el-icon-close"
                @click.stop='closeBox()'></span>
        </div>
        <video :src="videoInfo.url"
               ref="video"
               class="video"
               :poster='videoInfo.cover_img'
               :style="{width : '100%',height:'520px'}"
               controls="controls"
               autoplay></video>
      </div>
    </div>
  </transition>
</template>

<script>

import * as api from '../../../api'

export default {
  name: 'previewVideo',
  data() {
    return {
      visible: false,
      videoInfo: ''
    }
  },
  mounted() {
    this.$root.eventHub.$on('previewVideoModel', (data) => {
      this.visible = true
      this.videoInfo = data
    })


  },
  destroyed() {
    this.$root.eventHub.$off('previewVideoModel')
  },
  components: {

  },
  methods: {
    closeBox() {
      this.visible = false
    },

  },
  watch: {

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
@import '../../../styles/preview.styl'
</style>
